import { render } from "./ListMarketplaceValue.vue?vue&type=template&id=8009c572"
import script from "./ListMarketplaceValue.vue?vue&type=script&lang=js"
export * from "./ListMarketplaceValue.vue?vue&type=script&lang=js"

import "./ListMarketplaceValue.vue?vue&type=style&index=0&id=8009c572&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__